import React, { useState } from 'react';
import { Formik, Form, FastField, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import qs from 'querystring';
import {toast} from 'react-toastify'

const api = axios.create({ baseURL: 'https://api.setcorp.com.br' });

function Login({onSuccess}) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  async function doLogin(credentials) {
    setIsLoading(true)
    setError(null)
    try{
      const {data} = await api.post(
        '/usuario/login',
        qs.stringify({ ...credentials, env: 'prod', grant_type: 'password' }), //data
        { 'Content-Type': 'application/x-www-form-urlencoded' } //headers
        );

      const expires_in = data.expires_in || 25000

      window.localStorage.setItem('comunicado_session', new Date().getTime() + expires_in * 1000 )
      console.log(new Date().getTime() + expires_in)

      toast.success('Você se conectou com sucesso!')

      if(onSuccess) onSuccess()
    }catch(error){
      console.error(error)
      setError('Usuário ou senha incorretos')
    }
    setIsLoading(false)
  }

  return (
    <div className="container h-100">
      <style dangerouslySetInnerHTML={{__html: '#root{background-color: #fafafa}'}} />
      <div className="row h-100 align-items-center justify-content-center">
        <div className="col-12 col-lg-4 mx-auto">
          <div className="card card-body border-0 shadow">
            <img
              width="180"
              className="mx-auto mb-3"
              src="//repositorio.setcorp.com.br/imagens/logo/setpar.svg"
              alt="Setpar"
            />
            <p className="my-2 text-center">Por favor insira seu usuário e senha do GES para acessar</p>
            <Formik
              initialValues={{
                username: '',
                password: '',
              }}
              validationSchema={Yup.object().shape({
                username: Yup.string().required('Informe o usuário'),
                password: Yup.string().required('Informe a senha'),
              })}
              onSubmit={doLogin}
            >
              <Form>
                <div className="form-group">
                <label htmlFor="username">Seu usuário*</label>
                <FastField
                  name="username"
                  placeholder="Seu usuário"
                  required
                  className="form-control"
                  disabled={isLoading}
                />
                <ErrorMessage
                  name="username"
                  component="small"
                  className="text-danger"
                />
                </div>
                <div className="form-group">
                <label htmlFor="password">Sua senha*</label>
                <FastField
                  name="password"
                  type="password"
                  required
                  placeholder="Sua senha"
                  className="form-control"
                  disabled={isLoading}
                />
                <ErrorMessage
                  name="password"
                  component="small"
                  className="text-danger"
                />
                </div>
                {error && (
                  <div className="text-danger mb-2">{error}</div>
                )}
                <button type="submit" className="btn btn-primary" disabled={isLoading}>
                  {isLoading ? 'Entrando...' : 'Entrar'}
                </button>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
